export function equal(a, b) {
  return a.x === b.x && a.y === b.y;
}
